import { useRef, useState } from 'react'
import { Button, Carousel, Typography, } from 'antd';
import "./styles.css"

import rowLeft from '../../images/btn-left.png'
import rowRight from '../../images/btn-right.png'
import careerSwipeProcess from '../../images/CarouselImages/careerSwipeProcess.png'
import careerSwipeProcessFR from '../../images/CarouselImages/careerSwipeProcessFR.png'
import PlansViewFR from './ViewCarousel/PlansViewFR';
import InitialView from './ViewCarousel/InitialView';
import { useLocation } from 'react-router';
import CandidateCard from '../../common/CandidateCard';
import { candidateList, candidateFrance } from '../../firebase/data';
import PlansViewEN from './ViewCarousel/PlansViewEN';
import iconIRGTLogoWhite from '../../images/logo-CS-horizontal-morado.png'

const { Text } = Typography;
// Component

const CarouselGoCareerSwipe = () => {

    // Hooks React
    const carouselRef = useRef<any>(null);
    const location = useLocation();
    // States
    const [currentPage, setCurrentPage] = useState<number>(1);
    return (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', paddingTop: 20, paddingBottom: 30, height: '100%' }}>
            <Button
                className='buttonPrevPag'
                onClick={() => {
                    if (carouselRef.current) {
                        if (currentPage === 1) {

                            setCurrentPage(6)
                        } else {
                            setCurrentPage(currentPage - 1)
                        }
                        carouselRef.current.prev();
                    }
                }}
            >
                <Text style={{ fontSize: "5vh", color: 'white' }}>
                    <img className='iconRowStyle' src={rowLeft} alt={rowLeft} />
                </Text>
            </Button>

            <Carousel
                dots={false}
                className='containerViewsInCarousel'
                style={{ overflow: "hidden", minWidth: 1200, height: '90%' }}
                ref={carouselRef}
            >
                {/* View 1 */}
                <div className='containerCarouselView'>
                    <InitialView
                        title={
                            location.pathname === '/en/candidate' ?
                                'TOP TALENT IS HARD TO COME BY' :
                                'ATTIREZ LES MEILLEURS TALENTS EN PREMIER!'
                        }
                        subTitle={
                            location.pathname === '/en/candidate' ?
                                'Career Swipe is a Sourcing Service powered with AI for employers looking for qualified candidates without spending time posting or searching.' :
                                "Career Swipe est un service de recherche de candidature alimenté par l'IA, pour les employeurs qui veulent trouver des candidatures de qualité sans dédier de temps à la recherche et aux affichages."
                        }
                        listViewInitial={
                            location.pathname === '/en/candidate' ?
                                [
                                    'Receive qualified applications',
                                    'Hire faster',
                                    'Keep growing'
                                ] :
                                [
                                    'Recevez des candidatures qualifiées',
                                    'Embauchez plus rapidement',
                                    'Continuez à croître'
                                ]
                        }
                        descriptionParrafoOne={
                            location.pathname === '/en/candidate' ?
                                'Career Swipe offers you an innovative solution between passive posting and an expensive recruitment service.' :
                                "Career Swipe vous propose une solution innovante entre l'affichage passif et une coûteuse prestation de recrutement."
                        }
                        descriptionParrafoTwo={
                            location.pathname === '/en/candidate' ?
                                'A flexible and simple process to meet the candidates you want.' :
                                'Un processus flexible et simple pour rencontrer les candidatures que vous souhaitez.'}
                        descriptionParrafoThree={
                            location.pathname === '/en/candidate' ?
                                'From automated research of the best candidates to providing real-time labor market information, Career Swipe works to make your recruitment process a success.' :
                                "De la recherche automatisée des meilleures candidatures à fournir de l'information en temps réel sur le marché du travail , Career Swipe travaille pour faire de votre processus de recrutement un succès."}
                    />
                </div>

                <div className='containerCarouselView'>
                    <div style={{
                        height: '90vh', paddingLeft: 20, paddingTop: 40, paddingBottom: 40, paddingRight: 20,
                        display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', position: 'relative'
                    }}>
                        <img
                            alt="icon Irgt"
                            src={iconIRGTLogoWhite}
                            style={{ position: 'absolute', width: '40%', marginTop: '6%', top: 0 }}

                        />
                        <img
                            alt="icon Irgt"
                            src={location.pathname === '/en/candidate' ? careerSwipeProcess : careerSwipeProcessFR}
                            style={{
                                height: '100%', // Ajustado para utilizar el 100% de la altura del contenedor
                                maxWidth: '100%', // Se mantiene para asegurar que la imagen no exceda la anchura del contenedor
                                objectFit: 'contain', // Asegura que la imagen se ajuste dentro del contenedor sin perder proporciones
                                width: 'auto' // Ajusta el ancho automáticamente para mantener la proporción de la imagen
                            }}
                        />
                    </div>

                </div>

                <div className='containerCarouselView'>
                    <div style={{ height: '90vh', paddingLeft: 20, paddingTop: 40, paddingBottom: 40, paddingRight: 20, position: 'relative' }}>
                        <div style={{ position: 'absolute', top: '3%', right: '2%', borderRadius: 20, backgroundColor: 'blue', height: 30, width: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Text style={{ color: 'white', fontSize: 20 }}>1/3</Text>
                        </div>
                        <CandidateCard
                            educationListForm={location.pathname === '/en/candidate' ? candidateList[0].education : candidateFrance[0].education}
                            experienceListForm={location.pathname === '/en/candidate' ? candidateList[0].experience : candidateFrance[0].experience}
                            skillListForm={location.pathname === '/en/candidate' ? candidateList[0].skills : candidateFrance[0].skills}
                        />
                    </div>
                </div>

                <div className='containerCarouselView'>
                    <div style={{ height: '90vh', paddingLeft: 20, paddingTop: 40, paddingBottom: 40, paddingRight: 20, position: 'relative' }}>
                        <div style={{ position: 'absolute', top: '3%', right: '2%', borderRadius: 20, backgroundColor: 'blue', height: 30, width: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Text style={{ color: 'white', fontSize: 20 }}>2/3</Text>
                        </div>

                        <CandidateCard
                            educationListForm={location.pathname === '/en/candidate' ? candidateList[0].education : candidateFrance[1].education}
                            experienceListForm={location.pathname === '/en/candidate' ? candidateList[0].experience : candidateFrance[1].experience}
                            skillListForm={location.pathname === '/en/candidate' ? candidateList[0].skills : candidateFrance[1].skills}
                        />
                    </div>
                </div>

                <div className='containerCarouselView'>
                    <div style={{ height: '90vh', paddingLeft: 20, paddingTop: 40, paddingBottom: 40, paddingRight: 20, position: 'relative' }}>
                        <div style={{ position: 'absolute', top: '3%', right: '2%', borderRadius: 20, backgroundColor: 'blue', height: 30, width: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Text style={{ color: 'white', fontSize: 20 }}>3/3</Text>
                        </div>
                        <CandidateCard
                            educationListForm={location.pathname === '/en/candidate' ? candidateList[0].education : candidateFrance[2].education}
                            experienceListForm={location.pathname === '/en/candidate' ? candidateList[0].experience : candidateFrance[2].experience}
                            skillListForm={location.pathname === '/en/candidate' ? candidateList[0].skills : candidateFrance[2].skills}
                        />
                    </div>
                </div>

                <div className='containerCarouselView' >
                    {
                        location.pathname === '/en/candidate' ?
                            <PlansViewEN /> :
                            <PlansViewFR />
                    }
                </div>
            </Carousel>

            <Button
                className='buttonNextPag'
                onClick={() => {
                    if (carouselRef.current) {
                        /* console.log(carouselRef.current) */
                        if (currentPage === 6) {

                            setCurrentPage(1)
                        } else {
                            setCurrentPage(currentPage + 1)
                        }
                        carouselRef.current.next();
                    }
                }}
            >
                <Text style={{ fontSize: "5vh", color: 'white' }}>
                    <img className='iconRowStyle' src={rowRight} alt={rowRight} />
                </Text>
            </Button>

            <div style={{ width: "100vw", height: "2vh", position: "fixed", bottom: "6vh", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2 }}>
                {[1, 2, 3, 4, 5, 6].map(page => (
                    <div key={page} className={currentPage === page ? 'dotCarSelected' : 'dotCar'} />
                ))}
            </div>
        </div>
    )
}

export default CarouselGoCareerSwipe